import React from 'react';
import type { CurrencyCode } from '@noths/polaris-client-localisation';
import { priceFormatter } from '@noths/polaris-client-utils';

import * as styles from './Price.styles';

export interface PriceProps {
  currency?: CurrencyCode;
  price?: number;
}

export const Price = ({ currency, price }: PriceProps) => {
  if (!price || !currency) {
    return null;
  }

  const isNegative = Boolean(price < 0);

  return (
    <span css={styles.priceModifier}>
      <span css={styles.priceOperator} data-is-negative={isNegative}>
        {isNegative ? <>&minus;</> : <>&#43;</>}
      </span>
      <span>{priceFormatter(currency, price!).replace('-', '')}</span>
    </span>
  );
};
